import React from "react";
import ChartistGraph from "react-chartist";
import LoadingComponent from "src/components/General/Loading";
import "./lineChartStyles.min.css";

export interface DashboardGraphProps {
  labels: string[];
  series: { className: string; data: number[] }[];
  loading: boolean;
  demo: boolean;
}

export const DashboardGraph: React.FunctionComponent<DashboardGraphProps> = (props: DashboardGraphProps) => {
  const simpleLineChartData = {
    labels: props.labels,
    series: props.series,
  };
  return (
    <div>
      <svg viewBox="0 0 0 0" style={{ height: "0", width: "0" }}>
        <defs>
          <linearGradient id="gradient-a" x2="0%" y2="100%">
            {props.demo === true && (
              <>
                <stop offset="0%" stopColor="#c5c5c5" />
                <stop offset="100%" stopColor="#f1f1f1" />
              </>
            )}
            {props.demo === false && (
              <>
                <stop offset="0%" stopColor={props.loading === true ? "#c5c5c5" : "#f0f8ff"}>
                  {props.loading === true && (
                    <animate attributeName="stop-color" values="#c5c5c5;#f1f1f1;#c5c5c5;" dur="3s" repeatCount="indefinite" />
                  )}
                </stop>
                <stop offset="100%" stopColor={props.loading === true ? "#f1f1f1" : "#ffffff"}>
                  {props.loading === true && (
                    <animate attributeName="stop-color" values="#f1f1f1;#c5c5c5;#c5c5c5;#f1f1f1;" dur="3s" repeatCount="indefinite" />
                  )}
                </stop>
              </>
            )}
          </linearGradient>
        </defs>
      </svg>
      {props.loading === true && (
        <div
          style={{
            position: "absolute",
            top: "50%",
            left: "50%",
            // eslint-disable-next-line @typescript-eslint/naming-convention
            MozTransformOrigin: "translateX(-50%) translateY(-50%)",
            // eslint-disable-next-line @typescript-eslint/naming-convention
            WebkitTransform: "translateX(-50%) translateY(-50%)",
            transform: "translateX(-50%) translateY(-50%)",
          }}
        >
          <LoadingComponent />
        </div>
      )}
      {props.demo === true && (
        <div
          style={{
            position: "absolute",
            top: "50%",
            left: "50%",
            // eslint-disable-next-line @typescript-eslint/naming-convention
            MozTransformOrigin: "translateX(-50%) translateY(-50%)",
            // eslint-disable-next-line @typescript-eslint/naming-convention
            WebkitTransform: "translateX(-50%) translateY(-50%)",
            transform: "translateX(-50%) translateY(-50%)",
            background: "#FFFFFF",
            borderRadius: "4px",
          }}
        >
          <i className="sample-data">sample data</i>
        </div>
      )}
      <ChartistGraph
        className={props.loading ? "loading" : ""}
        options={{ fullWidth: true, showGridBackground: true }}
        data={simpleLineChartData}
        type={"Line"}
      />
    </div>
  );
};
